import React, { Component } from 'react';
import { FormControl, Badge, ListGroup, Spinner } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './AdvancedNotifications.css';
import { debounce } from 'lodash';

class UserSearchSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            searchResults: [],
            isSearching: false,
            selectedUsers: props.selectedUsers || [],
            showDropdown: false
        };
        this.searchUsers = debounce(this.performSearch, 300);
    }

    handleSearchChange = (e) => {
        const searchTerm = e.target.value;
        this.setState({ searchTerm, showDropdown: true });
        
        if (searchTerm.length >= 2) {
            this.setState({ isSearching: true });
            this.searchUsers(searchTerm);
        } else {
            this.setState({ searchResults: [], showDropdown: false });
        }
    }

    performSearch = async (searchTerm) => {
        try {
            const response = await fetch('http://localhost:4000/search-users-for-notification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ searchTerm })
            });
            
            const data = await response.json();
            if (data.status === 200) {
                this.setState({ 
                    searchResults: data.users || [],
                    isSearching: false 
                });
            }
        } catch (error) {
            console.error('Error searching users:', error);
            this.setState({ isSearching: false });
        }
    }

    selectUser = (user) => {
        const { selectedUsers } = this.state;
        const { onUserSelection } = this.props;
        
        // Check if user is already selected
        const isSelected = selectedUsers.some(u => u.id === user.id);
        
        if (!isSelected) {
            const updatedUsers = [...selectedUsers, user];
            this.setState({ 
                selectedUsers: updatedUsers,
                searchTerm: '',
                searchResults: [],
                showDropdown: false
            });
            onUserSelection(updatedUsers);
        }
    }

    removeUser = (userId) => {
        const { selectedUsers } = this.state;
        const { onUserSelection } = this.props;
        
        const updatedUsers = selectedUsers.filter(u => u.id !== userId);
        this.setState({ selectedUsers: updatedUsers });
        onUserSelection(updatedUsers);
    }

    getUserTypeLabel = (userType) => {
        return userType === 1 ? 'Rider' : 'Driver';
    }

    getPlatformIcon = (deviceType) => {
        if (deviceType === 'ios') return '🍎';
        if (deviceType === 'android') return '🤖';
        return '📱';
    }

    render() {
        const { 
            searchTerm, 
            searchResults, 
            isSearching, 
            selectedUsers,
            showDropdown 
        } = this.state;

        return (
            <div className={s.userSearchContainer}>
                <h4>Search and Select Users</h4>
                
                {/* Search Input */}
                <div className={s.searchInputWrapper}>
                    <FormControl
                        type="text"
                        placeholder="Search by name, email, phone, or ID..."
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                        className={s.searchInput}
                    />
                    
                    {/* Search Dropdown */}
                    {showDropdown && (
                        <div className={s.searchDropdown}>
                            {isSearching && (
                                <div className={s.searchingMessage}>
                                    <Spinner animation="border" size="sm" /> Searching...
                                </div>
                            )}
                            
                            {!isSearching && searchResults.length === 0 && searchTerm.length >= 2 && (
                                <div className={s.noResults}>No users found</div>
                            )}
                            
                            {!isSearching && searchResults.length > 0 && (
                                <ListGroup variant="flush">
                                    {searchResults.map(user => (
                                        <ListGroup.Item 
                                            key={user.id}
                                            action
                                            onClick={() => this.selectUser(user)}
                                            className={s.searchResult}
                                        >
                                            <div className={s.userInfo}>
                                                <div className={s.userMain}>
                                                    <strong>{user.firstName} {user.lastName}</strong>
                                                    <Badge 
                                                        bg={user.userType === 1 ? 'primary' : 'success'}
                                                        className={s.userTypeBadge}
                                                    >
                                                        {this.getUserTypeLabel(user.userType)}
                                                    </Badge>
                                                    {user.deviceType && (
                                                        <span className={s.platformIcon}>
                                                            {this.getPlatformIcon(user.deviceType)}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className={s.userDetails}>
                                                    {user.email && <span>{user.email}</span>}
                                                    {user.phoneNumber && (
                                                        <span> • {user.phoneDialCode}{user.phoneNumber}</span>
                                                    )}
                                                    {user.city && <span> • {user.city}</span>}
                                                </div>
                                                {user.lastLogin && (
                                                    <div className={s.userMeta}>
                                                        Last active: {new Date(user.lastLogin).toLocaleDateString()}
                                                    </div>
                                                )}
                                            </div>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            )}
                        </div>
                    )}
                </div>

                {/* Selected Users */}
                {selectedUsers.length > 0 && (
                    <div className={s.selectedUsersSection}>
                        <h5>Selected Users ({selectedUsers.length})</h5>
                        <div className={s.selectedUsersList}>
                            {selectedUsers.map(user => (
                                <div key={user.id} className={s.selectedUser}>
                                    <div className={s.selectedUserInfo}>
                                        <strong>{user.firstName} {user.lastName}</strong>
                                        <Badge 
                                            bg={user.userType === 1 ? 'primary' : 'success'}
                                            className={cx(s.userTypeBadge, s.small)}
                                        >
                                            {this.getUserTypeLabel(user.userType)}
                                        </Badge>
                                        {user.deviceType && (
                                            <span className={s.platformIcon}>
                                                {this.getPlatformIcon(user.deviceType)}
                                            </span>
                                        )}
                                    </div>
                                    <button
                                        type="button"
                                        className={s.removeButton}
                                        onClick={() => this.removeUser(user.id)}
                                        aria-label="Remove user"
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withStyles(s)(UserSearchSelect);